import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    marginTop: theme.spacing(4.125),
  },
  installmentsContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '464px',
    width: '100%',
  },
  installmentsHeader: {
    paddingTop: '0 !important',
    fontWeight: 600,
    fontSize: '0.875rem',
    color: theme.palette.primary.light,
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  installmentsRow: {
    padding: theme.spacing(2.5625, 3.5),
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.875rem',
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.secondary.main,
    },
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
}))
